module.exports = __webpack_public_path__ + "static/assets/e9fd315676d100386bf62f07abb7885a.png";